import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(public)/(main-layout)/group/')({
  loader: () => {
    throw redirect({ to: '/group/list', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
